import { render, staticRenderFns } from "./office-input.vue?vue&type=template&id=f1132326&scoped=true&"
import script from "./office-input.vue?vue&type=script&lang=js&"
export * from "./office-input.vue?vue&type=script&lang=js&"
import style0 from "./office-input.vue?vue&type=style&index=0&id=f1132326&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1132326",
  null
  
)

export default component.exports